import React, { Component } from 'react';
import { get, post } from 'axios';
import Notifications, {notify} from 'react-notify-toast';
import PerfectScrollbar from 'react-perfect-scrollbar';
import 'react-perfect-scrollbar/dist/css/styles.css';
import {Calendar, momentLocalizer, Views} from 'react-big-calendar';
import moment from 'moment';
import withDragAndDrop from 'react-big-calendar/lib/addons/dragAndDrop'
import 'react-big-calendar/lib/addons/dragAndDrop/styles.css'
import 'react-big-calendar/lib/css/react-big-calendar.css'
import momenttz from 'moment-timezone';
import { inject, observer } from 'mobx-react';

const DragAndDropCalendar = withDragAndDrop(Calendar)
const localizer = momentLocalizer(momenttz);

@inject('userStore')
@observer
class BookingScheduler extends Component {
    constructor(props){
        super(props);
        this.state = {
            quickviewVisible:false,
            artist:null,
            resourceMap:[],
            service_list:[],
            events:[],
            startTime:null,
            artist_list:[],
            schedule_increment:15
        }
        this.addEvent = this.addEvent.bind(this);
        this.CustomToolbar = this.CustomToolbar.bind(this);
    }

    componentDidMount(){
        var resources = [];
        var events = [];
        post('v2/get/booking_services', {
                booking_hash_id: this.props.booking.hash_id
            }, {
                auth: {username: this.props.userStore.token}
            }).then((res) => {
                this.setState({
                  schedule_increment:res.data.schedule_increment,
                  artist_list:res.data.artist_list,
                  service_list:res.data.service_list
                },() => {
                    this.state.artist_list.map((artist, index) => {
                        resources.push({ resourceId: artist.id, resourceTitle: artist.full_name })
                    });
                    if (this.state.artist_list.length === 0){
                        alert("Please assign an artist to proceed");
                    }
                    this.state.service_list.map((service, index) => {
                        if (service.bus_user_id){
                          let role = '';
                          if (service.participant.role){
                            role = ' (' + service.participant.role + ')';
                          }
                          events.push({start: new Date(service.start_datetime), end: new Date(service.stop_datetime), id:service.id, title:service.name + ' - ' + service.participant.full_name + role, resourceId:service.bus_user_id, bg_color:service.participant.bg_color, resize:service.resize})
                        }
                    });
                    this.setState({
                        resourceMap:resources,
                        events:events,
                        startTime: new Date(this.props.booking.min_date)
                    });
                });
          }).catch((error) => {
                console.log(error);
                return error;
          });

    }

    CustomToolbar(){
      return (
        <div className="toolbar-container">
        </div >
      )
    }

    addEvent(service, resourceId){
        const { events, startTime } = this.state;
        var endTime = moment(startTime).add(service.duration, 'm').toDate();
        const newEvent = {id:service.id, title:service.name + ' - ' + service.participant.full_name, start: new Date(startTime), end: new Date(endTime), resourceId:resourceId, bg_color:service.participant.bg_color,resize:service.resize}
        // save resource and timeslot
        var data = {id: service.id, start:momenttz(startTime).tz('utc').format(), end: momenttz(endTime).tz('utc').format(), resourceId:resourceId};
        post('v2/save/service_schedule', data, {
            auth: {username: this.props.userStore.token}
        }).then((res) => {
            if (res.data.errors === 0){
                const nextEvents = [...events]
                service.bus_user_id = resourceId;
                nextEvents.push(newEvent)
                this.setState({
                  events: nextEvents,
                })
            } else {
                alert(res.data.message);
            }
        }).catch((error) => {
            console.log(error);
            return error;
        });

    }

    moveEvent = ({ event, start, end, resourceId }) => {
        const { events } = this.state
        // // console.log(momenttz(start).tz('utc').format(), momenttz(end).tz('utc').format());
        // return false;

        const idx = events.indexOf(event)
        const updatedEvent = { ...event, start, end, resourceId }
        const nextEvents = [...events]
        var data = {id: event.id, start:momenttz(start).tz('utc').format(), end: momenttz(end).tz('utc').format(), resourceId:resourceId};
        post('v2/save/service_schedule', data, {
            auth: {username: this.props.userStore.token}
        }).then((res) => {
            if (res.data.errors === 0){
                if (res.data.duplicate === 1){
                    alert('You have a schedule conflict for ' + res.data.participant_name);
                }
                nextEvents.splice(idx, 1, updatedEvent)
                // save resource and timeslot
                this.setState({
                  events: nextEvents,
                })
            } else {
                alert(res.data.message);
            }
        }).catch((error) => {
            console.log(error);
            return error;
        });
      }


      resizeEvent = (data) => {
        const { start, end, event, resourceId } = data;
        const { events } = this.state;
        if (!event.resize){
          alert('This service cannot be resized')
          return false;
        }
        // save timeslot
        var data = {id: event.id, start:momenttz(start).tz('utc').format(), end: momenttz(end).tz('utc').format(), resourceId:resourceId};
        post('v2/save/service_schedule', data, {
            auth: {username: this.props.userStore.token}
        }).then((res) => {
            if (res.data.errors === 0){
                if (res.data.duplicate === 1){
                    alert('You have a schedule conflict for ' + res.data.participant_name);
                }
                const nextEvents = events.map(existingEvent => {
                    return existingEvent.id == event.id
                    ? { ...existingEvent, start, end }
                    : existingEvent
                });
                this.setState({
                    events: nextEvents,
                });
            } else {
                alert(res.data.message);
            }
        }).catch((error) => {
            console.log(error);
            return error;
        });

      };

    //
    // resizeEvent = (resizeType, { event, start, end, resourceId }) => {
    //     const { events } = this.state;
    //     if (!event.resize){
    //       alert('This service cannot be resized')
    //       return false;
    //     }
    //     // save timeslot
    //     var data = {id: event.id, start:momenttz(start).tz('utc').format(), end: momenttz(end).tz('utc').format(), resourceId:resourceId};
    //     post('v2/save/service_schedule', data, {
    //         auth: {username: this.props.userStore.token}
    //     }).then((res) => {
    //         if (res.data.errors === 0){
    //             if (res.data.duplicate === 1){
    //                 alert('You have a schedule conflict for ' + res.data.participant_name);
    //             }
    //             const nextEvents = events.map(existingEvent => {
    //                 return existingEvent.id == event.id
    //                 ? { ...existingEvent, start, end }
    //                 : existingEvent
    //             });
    //             this.setState({
    //                 events: nextEvents,
    //             });
    //         } else {
    //             alert(res.data.message);
    //         }
    //     }).catch((error) => {
    //         console.log(error);
    //         return error;
    //     });
    // }


    render() {
        // BigCalendar.momentLocalizer(moment); // or globalizeLocalizer
        const {backHandler, booking, modalHandler, height} = this.props;
        var unassignedCount = this.state.service_list.filter(function(service) { return !service.is_preview && !service.participant}).length;
        var unscheduledCount = this.state.service_list.filter(function(service) { return !service.bus_user_id && !service.is_preview && service.bk_client_user_id}).length;
        if (!booking) return <div className="alert alert-danger">No Booking Loaded<a className="btn btn-secondary btn-square btn-round pull-right" onClick={backHandler}><i className="fa fa-remove"></i></a></div>;
        if (this.state.resourceMap.length == 0) return <div className="alert alert-info">Loading Schedule...<a className="btn btn-secondary btn-square btn-round pull-right" onClick={backHandler}><i className="fa fa-remove"></i></a></div>;
        return (
            <React.Fragment>
            <Notifications />
            <div className="main-content pt-0">
                <header className="header-transparent">
                    <div className="header-info mb-0 mt-20 p-0">
                        <div className="left">
                            <h2 className="header-title">Set Schedule <small style={{display:'inline'}}>{booking.event_name} - {booking.ready_time}</small></h2>
                        </div>
                        <div className="right gap-items-2">
                            <a className="btn btn-secondary btn-square btn-round" onClick={backHandler}><i className="fa fa-remove"></i></a>
                        </div>
                    </div>
                </header>
                <div className="card">
                    <h5 className="card-title"><strong>Schedule</strong>
                        <div className="pull-right">
                            Unassigned: <strong style={{marginRight: 20+"px"}}>{unassignedCount}</strong>
                            Unscheduled:<strong>{unscheduledCount}</strong>
                            <div className="btn-group pl-20">
                                <button className="btn btn-primary dropdown-toggle" data-toggle="dropdown"><i className="fa fa-plus"></i> Add Services</button>
                                <div className="dropdown-menu">
                                {this.state.artist_list.map((artist, index) => {
                                    return <a key={index} className="dropdown-item" onClick={()=>this.setState({quickviewVisible:true, artist:artist})}>{artist.full_name}</a>
                                })}
                                </div>
                            </div>
                        </div>
                    </h5>
                    <div className="card-body">
                        <DragAndDropCalendar
                            selectable
                            localizer={localizer}
                            events={this.state.events}
                            onEventResize={this.resizeEvent}
                            onEventDrop={this.moveEvent}
                            resizable
                            resources={this.state.resourceMap}
                            resourceIdAccessor="resourceId"
                            resourceTitleAccessor="resourceTitle"
                            defaultView={Views.DAY}
                            defaultDate={new Date(booking.calendar_date)}
                            min={new Date(booking.min_date)}
                            max={new Date(booking.max_date)}
                            step={this.state.schedule_increment}
                            eventPropGetter={event => ({
                                style:{
                                    backgroundColor: event.bg_color
                                }
                            })}
                            components={{
                                toolbar:this.CustomToolbar
                            }}
                            style={{height:height - 120 + "px"}}
                        />
                    </div>
                </div>
            </div>
            <div className={this.state.quickviewVisible ? "quickview quickview-lg reveal" : "quickview quickview-lg"}>
            {this.state.artist ?
                <React.Fragment>
                <header className="quickview-header">
                    <p className="quickview-title lead fw-400">Add Services for {this.state.artist.full_name}</p>
                    <span className="close" onClick={() => this.setState({quickviewVisible:false})}><i className="ti-close"></i></span>
                </header>
                <PerfectScrollbar>
                <div className="quickview-body">
                    <div className="media-list media-list-hover media-list-divided media-list-xs">
                    {this.state.service_list.map((service, index) => {
                        if (!service.is_preview && !service.bus_user_id && service.participant) {
                            return (
                            <div key={index} className="media media-single cursor-pointer" onClick={() => this.addEvent(service, this.state.artist.id)}>
                                <div className="media-body">
                                  <p><strong>{service.name}</strong></p>
                                  {service.bk_client_user_id && service.participant ? <p>{service.participant.full_name}</p> : null}
                                </div>
                                <div className="media-right">
                                  <button className="btn btn-float btn-sm btn-success" onClick={() => this.addEvent(service, this.state.artist.id)}><i className="fa fa-plus"></i></button>
                                </div>
                            </div>)
                        }
                    })}
                    </div>
                </div>
                </PerfectScrollbar>
                <footer className="p-12 text-center">
                  <div className="btn-group btn-block btn-group-vertical">
                      <button className="btn btn-lg btn-outline btn-block btn-info" onClick={() => this.setState({quickviewVisible:false})}><i className="fa fa-fw fa-close"></i> Close</button>
                  </div>
                </footer>
                </React.Fragment>
            : <div className="alert alert-info">Loading...</div>}
            </div>
            </React.Fragment>
        )
  }
}

export default BookingScheduler;

// <footer className="card-footer">
//     <div className="btn-group pull-right">
//         <button className="btn btn-secondary" onClick={backHandler}>Back</button>
//     </div>
// </footer>



// WEBPACK FOOTER //
// ./src/components/business/BookingScheduler.js